const storageUnavailableInMemoryCache: Record<string, string> = {};
let canUseLocalStorage = true;

function setItem(key: string, value: string) {
  if (canUseLocalStorage) {
    try {
      return localStorage.setItem(key, value);
    } catch (ex) {
      console.error('LocalStorage not supported');
      console.error(ex);
      canUseLocalStorage = false;
    }
  }

  storageUnavailableInMemoryCache[key] = value;
  return undefined;
}

function getItem(key: string): string | null {
  if (canUseLocalStorage) {
    return localStorage.getItem(key);
  }
  return storageUnavailableInMemoryCache[key];
}

function tryParse(value: string | null) {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (err) {
    return null;
  }
}

export function setToken(token: string) {
  return setItem('authToken', token);
}

export function getToken() {
  return getItem('authToken');
}

export function setBizToken(token: string) {
  setToken('');
  return setItem('authBizToken', token);
}

export function getBizToken() {
  return getItem('authBizToken');
}

export function setUserPushToken(token: any) {
  return setItem('userPushToken', JSON.stringify(token));
}

export function getUserPushToken() {
  const token = getItem('userPushToken');
  return token ? tryParse(token) : null;
}

export function setCurrentBusinessId(businessId: number | undefined) {
  return setItem('currentBusinessId', JSON.stringify(businessId));
}

export function getCurrentBusinessId(): number | undefined {
  return tryParse(getItem('currentBusinessId')) ?? undefined;
}
